module.exports = ".modal-dialog {\n  width: 80%;\n  height: 80%;\n  max-height: 95%;\n  max-width: none;\n  overflow-y: auto; }\n\n.table-responsive {\n  height: 100%;\n  overflow: visible; }\n\n.redinput {\n  border: 1px red solid; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/limite-adicional-proposal/component/fixed-limit-la/fixed-limit-la.component.scss
// module id = ./src/app/limite-adicional-proposal/component/fixed-limit-la/fixed-limit-la.component.scss
// module chunks = main